<template>
    <vx-prompt
        persistent
        ignore-validation
        :title="title"
        :active.sync="isActive"
        :accept-text="nextButtonText"
        :prevent-close-on-accept="hasAcceptListener"
        @cancel="previousTab"
        @accept="nextTab"
        @close="close"
    >
        <vx-dynamic-form
            v-model="localValue"
            class="form"
            ref="dynamicForm"
            :steps="steps"
            @active-step-changed="trackActiveStep"
            @steps-updated="trackStepCount"
            @form-completed="formCompleted"
        />
        <template slot="cancel">
            <!-- div is to make sure the slot never defaults to its own button -->
            <div>
                <vx-button v-if="isFirstStep" color="warning" @click="close"> Cancel </vx-button>
                <vx-button v-else color="warning" @click="previousTab"> Back </vx-button>
                <slot
                    name="additionalButtons"
                    :payload="{
                        stepCount: stepCount,
                        isLastStep: isLastStep,
                        isFirstStep: isFirstStep
                    }"
                >
                </slot>
            </div>
        </template>
    </vx-prompt>
</template>

<script>
export default {
    name: 'vx-form-prompt',
    props: {
        title: {
            type: String,
            default: 'Something Something Form'
        },
        value: {
            type: Object,
            default: () => {}
        },
        active: {
            type: Boolean
        },
        steps: {
            type: Array,
            required: true
        },
        acceptText: {
            type: String,
            default: 'Submit'
        }
    },
    watch: {
        value: {
            handler: function (newV, oldV) {
                if (JSON.stringify(newV) == JSON.stringify(this.localValue)) {
                    return
                }
                if (!newV) {
                    this.localValue = {}
                    return
                }
                this.localValue = this.deepCopy(newV)
            },
            immediate: true,
            deep: true
        },
        localValue: {
            handler: function (newV, oldV) {
                this.$emit('input', newV)
            },
            deep: true
        },
        isActive: {
            handler: function (v) {
                if (!v) {
                    this.$emit('close')
                    this.reset()
                }
            }
        }
    },
    data() {
        return {
            localValue: {},
            activeStep: 0,
            stepCount_x: 0
        }
    },
    computed: {
        isActive: {
            get() {
                return this.active
            },
            set(v) {
                return this.$emit('update:active', v)
            }
        },
        hasAcceptListener() {
            return !!this.$listeners['completed']
        },
        stepCount() {
            return this.stepCount_x || this.steps.length
        },
        nextButtonText() {
            if (this.isLastStep) {
                return this.acceptText
            }
            return 'Next'
        },
        isLastStep() {
            return this.activeStep + 1 == this.stepCount
        },
        isFirstStep() {
            return this.activeStep < 1
        }
    },
    methods: {
        activateAllSteps() {
            this.$refs.dynamicForm.activateAllSteps()
        },
        close() {
            this.isActive = false
        },
        trackActiveStep(prev, next) {
            this.activeStep = next
        },
        trackStepCount(steps) {
            this.stepCount_x = steps.length
        },
        getWizard() {
            if (!this.isActive || !this.$refs.dynamicForm) {
                return {}
            }
            return this.$refs.dynamicForm.$refs.wizard
        },
        previousTab() {
            this.getWizard().prevTab()
        },
        async nextTab() {
            this.getWizard().nextTab()
        },
        formCompleted(result) {
            this.$emit('completed', result)
        },

        reset() {
            this.$refs.dynamicForm.reset()
        }
    }
}
</script>

<style lang="scss" scoped>
.form {
    padding-bottom: 0 !important;
    ::v-deep .wizard-header {
        display: none;
    }
    ::v-deep .wizard-card-footer {
        display: none;
    }
    ::v-deep .wizard-tab-container {
        margin-bottom: 0 !important;
    }
    ::v-deep .wizard-tab-content {
        padding-bottom: 0 !important;
    }
}
</style>
